import "./404.ea6882b2.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jqgCD", function(module, exports) {

$parcel$export(module.exports, "applyAuthState", function () { return $c5b1ef31d55b3d6b$export$e72d70ec8337520a; });
/**
 * The homepage renders the logged-out variant; with a session every
 * `[data-auth="in"]` element is shown and every `[data-auth="out"]` hidden,
 * in one pass (#508).
 */ function $c5b1ef31d55b3d6b$export$e72d70ec8337520a(root, loggedIn) {
    for (const el of root.querySelectorAll("[data-auth]")){
        const show = el.dataset.auth === "in" === loggedIn;
        el.classList.toggle("hidden", !show);
    }
}

});


var $5DLox = parcelRequire("5DLox");

var $jqgCD = parcelRequire("jqgCD");
// The header of the content pages (FAQ, legal; #621): "Sign in", or
// "Open app" with a session, like the homepage nav.
(0, $5DLox.supabase).auth.getSession().then(({ data: data })=>{
    if (!data.session) return;
    (0, $jqgCD.applyAuthState)(document, true);
});


//# sourceMappingURL=404.82982802.js.map
